import { InjectionToken } from "@angular/core";

export const BASE_PATH = new InjectionToken<string>("basePath");
